import React from 'react';
import { Box, Paper, Typography, Stepper, Step, StepLabel, StepContent } from '@mui/material';
import ExtensionIcon from '@mui/icons-material/Extension';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { BRAND } from '../../theme/brandTheme';

const EXTENSION_STEPS = [
  'Chrome\'a HypeCRO GA4 Extension\'ı yükleyin',
  'Extension popup\'ından giriş yapın (dashboard hesabınızla)',
  'Google Analytics 4 → Explore raporunda AB test tablosunu açın',
  'Extension ile raporu kaydedin — testler burada görünür',
];

/** Empty dashboard — extension setup or no filter matches */
const DashboardEmptyState = ({ filteredOut = false }) => {
  if (filteredOut) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 4,
          textAlign: 'center',
          border: `1px dashed ${BRAND.borderLight}`,
          borderRadius: 2,
          bgcolor: '#fafafa',
        }}
      >
        <FilterAltOffIcon sx={{ fontSize: 48, color: BRAND.textMuted, mb: 1 }} />
        <Typography variant="h6" sx={{ fontWeight: 600, color: BRAND.purple, mb: 1 }}>
          Filtrelere uygun test bulunamadı
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Filtreleri temizleyerek tüm testleri tekrar görebilirsiniz.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, md: 4 },
        border: `1px solid ${BRAND.borderLight}`,
        borderRadius: 2,
        bgcolor: '#fff',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
        <Box
          sx={{
            flex: '0 0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: { xs: '100%', md: 200 },
            height: 160,
            borderRadius: 2,
            bgcolor: BRAND.purple,
            color: '#fff',
          }}
        >
          <ExtensionIcon sx={{ fontSize: 80, opacity: 0.9 }} />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: BRAND.purple, mb: 1 }}>
            Henüz test yok
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            İlk AB test raporunuzu GA4 extension ile kaydettiğinizde burada listelenecek.
          </Typography>

          <Stepper orientation="vertical" activeStep={-1}>
            {EXTENSION_STEPS.map((label) => (
              <Step key={label} expanded>
                <StepLabel
                  StepIconProps={{
                    sx: { color: BRAND.purple, '& .MuiStepIcon-text': { fill: '#fff' } },
                  }}
                >
                  <Typography variant="body2">{label}</Typography>
                </StepLabel>
                <StepContent />
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>
    </Paper>
  );
};

export default DashboardEmptyState;
